import { Button as PRButton } from 'primereact/button';
import { useState } from 'react';
import { BodySmallRegular, Icon, PlusIcon, XIcon, XStack } from 'smoothie';

import { AddNewTextEditor } from '../../common/components/GridCellEditors';

interface AddNewWorkflowGoalTaskProps {
    onAdd: (task: { description: string }) => void;
}

export const AddNewWorkflowGoalTask = ({
    onAdd,
}: AddNewWorkflowGoalTaskProps) => {
    const [isAddingNew, setIsAddingNew] = useState(false);
    const [description, setDescription] = useState('');

    const reset = () => {
        setIsAddingNew(false);
        setDescription('');
    };

    return (
        <XStack
            alignItems="center"
            paddingHorizontal={8}
            paddingTop={4}
            gap={12}
            width="100%"
        >
            <XStack flexGrow={1} alignItems="center" gap={16}>
                <Icon size={16} icon={PlusIcon} color="$gray800" />
                {isAddingNew ? (
                    <XStack alignItems="center" gap={8} width="80%">
                        <AddNewTextEditor
                            value={description}
                            onChange={setDescription}
                        />
                        <PRButton
                            label="Add"
                            size="small"
                            severity="success"
                            outlined
                            onClick={() => {
                                if (description != null) {
                                    onAdd({ description });
                                    reset();
                                }
                            }}
                        />
                        <PRButton
                            size="small"
                            severity="secondary"
                            outlined
                            onClick={() => {
                                reset();
                            }}
                        >
                            <Icon icon={XIcon} />
                        </PRButton>
                    </XStack>
                ) : (
                    <BodySmallRegular
                        width="60%"
                        color="$gray800"
                        paddingVertical={10}
                        paddingHorizontal={8}
                        marginLeft={-8}
                        borderRadius={6}
                        borderWidth={1}
                        borderColor="transparent"
                        hoverStyle={{
                            cursor: 'text',
                            borderColor: '$gray300',
                        }}
                        onPress={() => {
                            setIsAddingNew(true);
                        }}
                    >
                        New task
                    </BodySmallRegular>
                )}
            </XStack>
        </XStack>
    );
};
